import { Icon } from "@iconify/react/dist/iconify.js";
import { ButtonBase, Checkbox, Divider, Grid, Popover } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import Helpers from "../../helpers/helpers";
import CustomButton from "../Form/CustomButton";

export default function PopoverFilter2({ module, value, marginLeft, marginRight, filterData, setValue, placeholder, paddingInline }) {
    const [menu, setMenu] = useState(null);
    const [checkedAll, setCheckedAll] = useState();
    const [valueChecked, setValueChecked] = useState([]);

    const openPopoverHandle = useCallback((event) => {
        setMenu(event.currentTarget);
    }, []);

    const closePopover = useCallback(() => {
        setMenu(null);
    }, []);

    useEffect(() => {
        if (value === 'all') {
            // setCheckedAll(true);
            setValueChecked([]);
        } else 
        if (Array.isArray(value)) {
            setValueChecked(value || []);
        }
    }, [value])

    useEffect(() => {
        if (filterData) {
        }
    }, [filterData])

    useEffect(() => {
        if (valueChecked.length === filterData.length) {
            setCheckedAll(true);
        } else if ((valueChecked.length !== filterData.length) && checkedAll) {
            setCheckedAll(false);
        }
    }, [valueChecked]);

    const handleValueChecked = (val) => {
        let temp = checkedAll ? [] : [...valueChecked];
        checkedAll && setCheckedAll(false);
        if (temp.includes(val)) {
            temp = temp.filter((x) => x !== val);
        } else {
            temp.push(val);
        }
        setValueChecked(temp);
    }

    const handleCheckAll = () => {
        let currentCheckedAll = !checkedAll;
        if(currentCheckedAll){
        let allIds = [];
            filterData?.forEach((x) => {
                allIds.push(x.id);
            })
            setValueChecked(allIds);
        } else {
            setValueChecked([]);
        }
    }

    const handleApply = () => {
        setValue(valueChecked);
        closePopover();
    }

    const handleClearAll = () => {
        setCheckedAll(false);
        setValueChecked([]);
    }
    
    return (
        <React.Fragment>
            <ButtonBase
                style={{
                    height: 33,
                    borderRadius: 20,
                    backgroundColor: value !== 'all' ? '#F9F9F9' : 'white',
                    color: '#101010',
                    padding: 7,
                    paddingInline: paddingInline || 20,
                    width: "auto",
                    border: value !== 'all' ? "1px solid #808588" : "1px solid #E9E9E9",
                    marginRight: marginRight || 0,
                    marginLeft: marginLeft || 0,
                }}
                onClick={openPopoverHandle}
            >
                {
                    placeholder ?
                        <div className="d-flex justify-content-between w-100 px-2">
                            {
                                !value || (Array.isArray(value) && value.length === 0) ?
                                    <>
                                        <div className="subheader-2 d-flex" style={{ color: '#999999' }}>{module}</div>
                                    </>
                                    : <>
                                        <div>{module} ({value?.length || 0})</div>
                                    </>
                            }
                            <Icon icon={'mdi:chevron-down'} style={{ color: !value || (Array.isArray(value) && value.length === 0) ? '#999999' : '#434343', fontSize: "20px", paddingLeft: "0px" }} />
                        </div>
                        :
                        <div className="d-flex align-items-center">
                            <span className="subheader-2 d-flex" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}><span style={{ color: '#101010', marginLeft: 5 }}>{value === 'all' || value?.length === 0 ? module : value?.length > 0 ? `${value.length} selected` : 'all'}</span></span>
                            <Icon icon={'mdi:chevron-down'} style={{ marginLeft: 15, color: '#434343', fontSize: "20px", paddingLeft: "0px" }} />
                        </div>
                }
            </ButtonBase>
            <Popover
                sx={{
                    "& .MuiPaper-root": {
                        boxShadow: "0 2px 4px rgba(16, 16, 16, 0.08)",
                        borderRadius: "8px",
                        overflowX: 'auto'
                    },
                }}
                open={!!menu}
                anchorEl={menu}
                onClose={closePopover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
            >
                <div className="px-4 pt-4 pb-2" style={{ position: 'relative' }}>
                    <div className="px-2 pb-3" style={{ maxHeight: 400, overflow: 'auto', overflowX: 'hidden', minWidth: 300, maxWidth: 370, }}>
                        <Grid container spacing={2}>
                            <Grid item sm={10.5} xs={10.5} className="d-flex align-items-center text-bold">
                                All
                            </Grid>
                            <Grid item sm={1.5} xs={1.5} className="d-flex align-items-center">
                                <Checkbox checked={checkedAll && (filterData.length === valueChecked.length)}
                                    checkedIcon={Helpers.checkIcon()}
                                    icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '1px solid #E9E9E9' }}></div>}
                                    sx={{
                                        '&.Mui-checked': {
                                            color: "#D7114D",
                                        },
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 18,
                                        },
                                    }}
                                    value={checkedAll || filterData.length === valueChecked.length}
                                    onChange={(event) => handleCheckAll()} />
                            </Grid>
                            {
                                filterData?.map((x, idx) => {
                                    return (
                                        <>
                                            {
                                                <>
                                                    <Grid item sm={10.5} xs={10.5} className="d-flex align-items-center" key={`options-name-${idx}`}>
                                                        {x.name}
                                                    </Grid>
                                                    <Grid item sm={1.5} xs={1.5} className="d-flex align-items-center" key={`options-checkbox-${idx}`}>
                                                        <Checkbox checked={valueChecked?.includes(x?.id)}
                                                            checkedIcon={Helpers.checkIcon()}
                                                            icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '1px solid #E9E9E9' }}></div>}
                                                            sx={{
                                                                '&.Mui-checked': {
                                                                    color: "#D7114D",
                                                                },
                                                                '& .MuiSvgIcon-root': {
                                                                    fontSize: 18,
                                                                },
                                                            }}
                                                            value={x?.id}
                                                            onChange={(event) => handleValueChecked(x?.id)} />
                                                    </Grid>
                                                </>
                                            }
                                        </>
                                    )
                                })
                            }
                        </Grid>
                    </div>
                    <Divider />
                    <div className="py-2 d-flex justify-content-between pt-3" style={{ backgroundColor: 'white' }}>
                        <CustomButton
                            title={'Clear'}
                            press={() => { handleClearAll() }}
                            backgroundColor={'transparent'}
                            borderStyle={"none"}
                            textColor={'#594A4E'}
                        />
                        <CustomButton
                            title={'Apply'}
                            press={() => { handleApply() }}
                        />
                    </div>
                </div>
            </Popover>
        </React.Fragment>
    )
}